import React from 'react';
import { Provider } from 'react-redux';

import store from '@search/store';
import App from '@search/components/App';

const Search = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default Search;
